export default __webpack_public_path__ + "assets/swagger.d5f1f59b.svg";